import React from "react";

import banner1 from "../images/banner_v1.jpg";
import banner2 from "../images/banner-2.avif";
import banner3 from "../images/banner-3.avif";
import banner4 from "../images/banner-4.avif";

export default function BannerGrid() {
    return (
        <section className="banners">
            <div className="hero">
                <img src={banner1} alt="Hero" />
            </div>
            <div className="small-banners">
                {/* <button style={{ border: "none", background: "none" }} onClick={() => window.open(banner2, "_blank")}>
                    <img src={banner2} alt="b2" />
                </button> */}
                {/* <button style={{ border: "none", background: "none" }} onClick={() => window.open(banner3, "_blank")}>
                    <img src={banner3} alt="b2" />
                </button>
                <button style={{ border: "none", background: "none" }} onClick={() => window.open(banner4, "_blank")}>
                    <img src={banner4} alt="b3" />
                </button> */}
            </div>
        </section>
    );
}